import { defineStore } from "pinia";
import { ref } from "vue";
import { Member } from "@/common/types";

export const userStore = defineStore("userInfo", () => {
  const userInfo = ref({} as Member);
  const isLogin = ref(false);

  const login = (data: Member) => {
    userInfo.value = data;
    isLogin.value = true;
  };

  const logout = () => {
    userInfo.value = {} as Member;
    isLogin.value = false;
  };

  return { userInfo, login, logout, isLogin };
});
